import { DataApiCache } from './Cache';

const baseURL = process.env.REACT_APP_PMI_API_BASE_URL;
const _api = new DataApiCache();

const DYNAMIC_COLLECTION_PATH = 'dynamic-collections';

export const uploadCollection = async (doc: {
    collectionName: string;
    primaryKeyColumns: string[];
    tabName: string;
    rows: any[];
}) => {
    try {
        const address = `${baseURL}/${DYNAMIC_COLLECTION_PATH}/upload`;
        const data = await _api.post(address, doc);
        return data;
    } catch (ex) {
        throw new Error(`Failed to upload dynamic collection: ${ex}`);
    }
};

export const getDynamicCollectionData = async (
    collectionName: string,
    searchParams?: { filters: Array<{ property: string; value: string | number; operator?: string }> }
) => {
    try {
        const url = `${baseURL}/${DYNAMIC_COLLECTION_PATH}/search/${collectionName}`;
        const data = await _api.post(url, searchParams ?? { filters: [] });
        return data;
    } catch (ex) {
        throw new Error(`Failed to get dynamic collection: ${collectionName}`);
    }
};


export const getDynamicCollectionsRegistry = async () => {
    try {
        const url = new URL(`${baseURL}/${DYNAMIC_COLLECTION_PATH}/registry`);
        url.searchParams.append('ts', Date.now().toString()); // Add timestamp query param toa void cache
        const data = await _api.get(url.toString());
        return data;
    } catch (ex) {
        throw new Error(`Failed to fetch dynamic collections registry: ${ex}`);
    }
};

export const deleteCollection = async (collectionName: string) => {
    try {
        const address = `${baseURL}/${DYNAMIC_COLLECTION_PATH}/${collectionName}`;
        const data = await _api.delete(address);
        return data;
    } catch (ex) {
        throw new Error(`Failed to delete dynamic collection: ${collectionName}`);
    }
};
